module.exports = __webpack_public_path__ + "img/bs_banner_pt.5f6acbe0.jpg";